/**
 * BST Find a Dealer — tab panels (dealer locator / online retailers)
 */
(function () {
  'use strict';

  const ACTIVE_CLASS = 'is-active';
  const SELECTORS = {
    root: '[data-bst-find-dealer]',
    tab: '[data-bst-find-dealer-tab]',
    panel: '[data-bst-find-dealer-panel]',
  };

  let stockistScriptRequested = false;

  function loadStockistScript() {
    if (stockistScriptRequested) return;
    stockistScriptRequested = true;

    const script = document.createElement('script');
    script.src = 'https://stockist.co/embed/v1/widget.min.js';
    script.async = true;
    document.head.appendChild(script);
  }

  function setPanelHidden(panel, hidden) {
    panel.classList.toggle(ACTIVE_CLASS, !hidden);
    panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    panel.toggleAttribute('hidden', hidden);

    if (!hidden && panel.dataset.bstFindDealerPanel === 'dealer') {
      loadStockistScript();
    }
  }

  function activateTab(root, tabKey) {
    const tabs = [...root.querySelectorAll(SELECTORS.tab)];
    const panels = [...root.querySelectorAll(SELECTORS.panel)];

    tabs.forEach((tab) => {
      const isActive = tab.dataset.bstFindDealerTab === tabKey;
      tab.classList.toggle(ACTIVE_CLASS, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.bstFindDealerPanel === tabKey;
      setPanelHidden(panel, !isActive);
    });

    root.dispatchEvent(
      new CustomEvent('bst:find-dealer-tab-change', {
        bubbles: true,
        detail: { tabKey },
      })
    );
  }

  function bindTabs(root) {
    const tabs = [...root.querySelectorAll(SELECTORS.tab)];
    const panels = [...root.querySelectorAll(SELECTORS.panel)];

    if (!tabs.length || !panels.length) return;

    const panelKeys = new Set(panels.map((panel) => panel.dataset.bstFindDealerPanel));
    const validTabs = tabs.filter((tab) => panelKeys.has(tab.dataset.bstFindDealerTab));

    if (!validTabs.length) return;

    const initial =
      root.querySelector(`${SELECTORS.tab}.${ACTIVE_CLASS}`)?.dataset.bstFindDealerTab ||
      validTabs[0].dataset.bstFindDealerTab;

    activateTab(root, initial);

    validTabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(root, tab.dataset.bstFindDealerTab));

      tab.addEventListener('keydown', (event) => {
        const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        const index = validTabs.indexOf(tab);
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % validTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + validTabs.length) % validTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = validTabs.length - 1;

        validTabs[nextIndex]?.focus();
        activateTab(root, validTabs[nextIndex].dataset.bstFindDealerTab);
      });
    });
  }

  function initRoot(root) {
    if (root._bstFindDealerInit) return;
    root._bstFindDealerInit = true;
    bindTabs(root);
  }

  function init() {
    document.querySelectorAll(SELECTORS.root).forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTORS.root).forEach(initRoot);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
